<script setup lang="ts">
import { router } from '@inertiajs/vue3';
import { Button } from '@youcan/celeste';
import BannerImg from '@/assets/svg/ads/onboarding/banner/banner.webp';

defineEmits(['close']);

function redirectTo(path: string) {
  router.visit(route(path));
}
</script>

<template>
  <div class="wrapper">
    <div class="content">
      <h3 class="title">
        {{ $t('ads.onboarding.banner.title') }}
      </h3>
      <p class="text">
        {{ $t('ads.onboarding.banner.body') }}
      </p>
      <Button class="cta-button" @click="redirectTo('ads.onboarding.index')">
        {{ $t('ads.onboarding.banner.button') }}
      </Button>
    </div>
    <img :src="BannerImg" class="banner-img">
    <button class="close" @click="$emit('close')">
      <i class="i-celeste-close-large-fill" />
    </button>
  </div>
</template>

<style scoped>
.wrapper {
  display: flex;
  position: relative;
  align-items: center;
  justify-content: space-between;
  padding: 24px;
  border: 1px solid #eeeced;
  border-radius: 16px;
  background: linear-gradient(90deg, #fff -3.31%, #fefdfe -1.35%, #fefdfe 7.71%, #fefbfd 29.48%, #fdf7fa 95.45%);
  gap: var(--spacing-16);
}

.content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-width: 60ch;
  gap: var(--spacing-8);
}

.title {
  color: var(--text-strong-950);
  font: var(--title-h6-title);
  font-weight: 600;
  text-shadow: 0 -2px 0 var(--color-neutral-0);
}

.text {
  color: var(--color-text-sub-600);
  font: var(--subheading-sm);
}

.close {
  position: absolute;
  z-index: 10;
  top: 12px;
  right: 12px;
  cursor: pointer;
}

.banner-img {
  right: 24px;
  bottom: 16px;
  max-width: 256px;
  height: auto;
}

.cta-button {
  margin-top: var(--spacing-8);
}

@screen lt-lg {
  .wrapper {
    display: flex;
    flex-direction: column-reverse;
    justify-content: center;
  }

  .content {
    max-width: 100%;
  }

  .banner-img {
    display: none;
  }

  .cta-button {
    margin-top: var(--spacing-8);
  }
}
</style>
